import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Head from "next/head";

// import { NextSeo } from "next-seo";

const MetaHeadSEO = (props) => {
    let { metaTitle, metaDescription } = props;

    metaDescription = metaDescription?.slice(0, 155);

    if (metaTitle?.length < 40) {
        metaTitle += Array(40 - (metaTitle?.length || 0))
            .fill(" ")
            .join("");
    }

    const { t, i18n } = useTranslation();

    const [LOCATION, setLOCATION] = useState({});

    useEffect(() => {
        const _location = {
            ...JSON.parse(JSON.stringify(window.location)),
            canonical: window.location.origin + window.location.pathname,
        };

        if (JSON.stringify(LOCATION) === JSON.stringify(_location)) return;

        setLOCATION(_location);
    }, [LOCATION, props]);

    return (
        <>
            <Head>
                <meta name="viewport" content="initial-scale=1, width=device-width" />
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />

                <link rel="canonical" href={LOCATION.canonical} />
                <meta name="robots" content="all" />
                <meta name="publisher" content={t("Główny Urząd Statystyczny")} />

                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content="https://dbw.stat.gov.pl/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={`${LOCATION.origin}/images/og-bg.jpg`} />
                <meta property="og:image:alt" content={t("Dziedzinowe Bazy Wiedzy")} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:locale" content={i18n.language} />
                <meta property="og:site_name" content={t("Dziedzinowe Bazy Wiedzy")} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@GUS_STAT" />
                <meta name="twitter:creator" content="@GUS_STAT" />
            </Head>

            {/* <NextSeo
                title={metaTitle}
                description={metaDescription}
                canonical="https://dbw.stat.gov.pl/"
                openGraph={{
                    type: "website",
                    url: "https://dbw.stat.gov.pl/",
                    siteName: t("Dziedzinowe Bazy Wiedzy"),
                    locale: i18n.language,
                    images: [
                        {
                            url: "https://dbw.stat.gov.pl/images/og-bg.jpg",
                            width: 1200,
                            height: 630,
                            alt: t("Dziedzinowe Bazy Wiedzy"),
                        },
                    ],
                }}
                twitter={{
                    site: "@GUS_STAT",
                    handle: "@GUS_STAT",
                    cardType: "summary_large_image",
                    title: metaTitle,
                    description: metaDescription,
                }}
            /> */}
        </>
    );
};

export default MetaHeadSEO;
